import Api from './api'
import XLSX from "xlsx";
import moment from "moment/moment";
var imageTree = {}
var skuReplacements = []
function createParentLine(basisData, materialData) {
const parentLine = {
    feed_product_type: materialData.feed_product_type,
    item_sku : materialData.parentSKU,
    brand_name: basisData.brand_name,
    item_name: materialData.namePrefix,
    manufacturer: basisData.brand_name,
    parent_child: basisData.parent,
    variation_theme: materialData.variation,
    update_delete:basisData.update_delete_partiel,
    recommended_browse_nodes: materialData.browse_node,
    generic_keywords: materialData.generic_keywords,
}
return parentLine
}

function downloadExceFromJson(json, fileNamePrefix= ""){
    let ws = XLSX.utils.json_to_sheet(json)
    var ws_name = "SheetJS";
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, ws_name);
    let formatted_date = moment(new Date()).format('DD-MM-YYYY_HH-mm')
    XLSX.writeFile(wb, `${fileNamePrefix}_${formatted_date}.xlsx`);
}

function downloadCSVFromJSON(json, filenamePrefix = ""){
    const DELIMITER = "\t"
    debugger //eslint-disable-line no-debugger
    const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
    const header = Object.keys(json[0])
    const csv = [
        header.join(DELIMITER), // header row first
        ...json.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(DELIMITER))
    ].join('\r\n')

    console.log(csv)

    let formatted_date = moment(new Date()).format('DD-MM-YYYY_HH-mm')
    const anchor = document.createElement('a');
    anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
    anchor.target = '_blank';
    anchor.download = `${filenamePrefix}_${formatted_date}.csv`;
    anchor.click();
}
function createParentLineForFile(basisData, materialData) {
    return getImagesFromDB(materialData.material)
        .then(imgTree => {

            imageTree = imgTree
            const images = getImages('', '', materialData.material);
            const parentLine = {
                feed_product_type: materialData.feed_product_type,
                item_sku: materialData.parentSKU,
                brand_name: basisData.brand_name,
                item_name: materialData.namePrefix,
                manufacturer: basisData.brand_name,
                parent_child: basisData.parent,
                variation_theme: materialData.variation,
                update_delete: basisData.update_delete,
                recommended_browse_nodes: materialData.browse_node,
                generic_keywords: materialData.generic_keywords,
                relationship_type: basisData.relationship_type,
                main_image_url: images.images[0]
            };

            return parentLine
        })


}


 function getEANs(amount = 0, isDemo){

    if(isDemo){
        return new Promise((resolve, reject) => {
           resolve(Array(amount).fill("9999999999999"))
        });
        // return new Promise((resolve, reject))
        // return Array(amount).fill("9999999999999")
    }

     return new Promise((resolve, reject) => {

         Api.ean.getEANs(amount)
         // fetch("http://localhost:3000/api/ean?amount=" + amount +"&authToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImFudG9uIiwiaWF0IjoxNjM4MzU0NDM4fQ.aD7cRmn3jdhyXuIfiC5fJIN4pIjgGnj850-gn-yZGQ4")
             .then(response => response.data)
             .then(response => {
                 resolve(response)
             }).catch(e => {
             reject(e)
         })
     });
}

function createItemLines(basisData, fileJSON, selectedMaterial, shippingOption, isDemo, price, uploadSizes){
    let itemLines = [];
    let eans = [];
    let uploadSize;
    debugger//eslint-disable-line no-debugger

    if(selectedMaterial.uploadSize)
        uploadSize = uploadSizes.filter(item => {
            // debugger//eslint-disable-line no-debugger

            return item._id === selectedMaterial.uploadSize
        })[0]
    return getEANs(fileJSON.length, isDemo)
        .then(eanList => {
            eans = eanList
            return getImagesFromDB(selectedMaterial.material)
        })
        .then(imgTree => {
            imageTree = imgTree
            console.log(imgTree)
            return loadSKUReplacements()
        })
        .then(skuRepl => {
            skuReplacements = skuRepl
            fileJSON.forEach((item, index) => {
                // debugger//eslint-disable-line no-debugger

                const line = getItemLine(item.model, item.motive, basisData, selectedMaterial, shippingOption, eans[index], price, uploadSize)
                itemLines.push(line)
            })
            return itemLines
        })

    // return itemLines
}

async function loadSKUReplacements(){
    return new Promise((resolve, reject) => {
        Api.sku.getSKUReplacements()
            .then(response => response.data)
            .then(response => {
                resolve(response)
            }).catch(e => {
            reject(e)
        })
    });
}

function updateEANsInDatabase(itemLines) {
    debugger//eslint-disable-line no-debugger

    if(itemLines.length > 1){
        // debugger
        itemLines.shift()
        debugger//eslint-disable-line no-debugger

        Api.history.writeHistory(itemLines)
    }

}

function createSKU(selectedMaterialTXT, model, motive, variation) {
    let sku = '';
    switch (variation) {
        case "SizeName-ColorName":
            sku = selectedMaterialTXT + "_" + model + "_" + motive;
            break;
        case "SizeName":
            sku = selectedMaterialTXT + "_" + model;
            break;
        case "ColorName":
            sku = selectedMaterialTXT + "_" + motive;
            break;
        default:
            sku = selectedMaterialTXT + "_" + model + "_" + motive;
            break;
    }

    if(sku.length>=40 && skuReplacements && skuReplacements.length != 0){
        for(let item of skuReplacements){
            sku = sku.replace(item.original, item.replaced)
        }
    }
    return sku
}

function getItemName(selectedMaterial, model, motive) {
    let name = selectedMaterial.namePrefix;
    debugger//eslint-disable-line no-debugger
    if(model)
        name = name.replaceAll('%SIZE%', model)
    if(motive)
        name = name.replaceAll('%COLOR%', motive)
    return name;
}

function getImagesFromDB(material){
    return new Promise((resolve, reject) => {
        Api.images.getImages(material)
        // fetch("http://localhost:3000/api/images?material="+ material + "&authToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImFudG9uIiwiaWF0IjoxNjM4MzU0NDM4fQ.aD7cRmn3jdhyXuIfiC5fJIN4pIjgGnj850-gn-yZGQ4", data)
            .then(response => response.data)
            .then(response => {
                resolve(response)
            }).catch(e => {
            reject(e)
        })
    });
}


function getImages(motive, model, material) {

    motive = motive.toLowerCase()
    model = model.toLowerCase();
    const prefix = "https://hlworld.de/AEG"
    let suffix =  '';

    let materialImage = imageTree;
    let motiveImage = materialImage ? materialImage[motive] : undefined;
    let images = []
    if(materialImage && motiveImage && motiveImage[model]){
        images = motiveImage[model].items
        suffix =  `${material}/${motive}/${model}/`;

    }else if(motiveImage){
        images = motiveImage.items
        suffix =  `${material}/${motive}`;
    }else if (materialImage){
        suffix =  `${material}`;
        images = materialImage.items
    }
    let swatch_image_url = `${prefix}/${material}/${motive}/1.jpg`

    images = images.map(item => `${prefix}/${suffix}/${item}`)

    return {images, swatch: swatch_image_url}


}

function getModelName(selectedMaterialTXT, model, motive) {
    return `${selectedMaterialTXT} ${model} - ${motive}`;
}

function getColorMap(motive) {
    return '';
}


function getCompatiblePhoneModels(model, selectedMaterial) {
    try {
        if (selectedMaterial.compatibleModels) {
            for (let arrayItem  of selectedMaterial.compatibleModels) {
                if (arrayItem.includes(model)) return arrayItem
            }
        }
    }catch (e) {
        console.log("Could not find model in selected Material.")
    }
    return []

}


function getPattern(motive) {
    return '';
}

function getPrice(price) {
    const DEFAULT_PRICE = '10.00';
    try {
        if(price.length === 0) return DEFAULT_PRICE
        price = price.replace(",",".").replace(/[^0-9.]/g, '')

        return price
    }catch (e) {
        return DEFAULT_PRICE
    }

}

function getSizeLength(uploadSize, model, motive) {
    let combinationSize
    // debugger//eslint-disable-line no-debugger
    if(uploadSize && uploadSize.sizes && uploadSize.sizes.length > 0){
        combinationSize = uploadSize.sizes.filter(size => {
            if(uploadSize.type === 'size'){
                return size.size.trim() === model.toLowerCase().trim()
            }else if(uploadSize.type === 'color') {
                    return size.color.trim() === motive.toLowerCase().trim()

            }else if(uploadSize.type === 'size-color') {
                return ((size.color.trim() === motive.toLowerCase().trim()) && (size.size.trim() === model.toLowerCase().trim()))
            }
        })
    }
    if(combinationSize) return combinationSize[0]
    else return combinationSize
}

function getItemLine(model, motive, basisData, selectedMaterial, shippingOption, pEan, pPrice, uploadSize) {
    let sku = createSKU(selectedMaterial.material, model, motive, selectedMaterial.variation)
    let ean = pEan
    let itemSize = getSizeLength(uploadSize, model, motive)
    let itemName = getItemName(selectedMaterial, model, motive)
    let modelName = getModelName(selectedMaterial.material, model, motive);
    let images = getImages(motive, model, selectedMaterial.material);
    let colorMap = getColorMap(motive);
    let price = getPrice(pPrice)
    let motiveField = ['SizeName-ColorName', 'ColorName'].includes(selectedMaterial.variation)? motive : ''
    let modelField = ['SizeName-ColorName', 'SizeName'].includes(selectedMaterial.variation)? model : ''
    let pattern = getPattern(motive)
    let compatibleModels = getCompatiblePhoneModels(model, selectedMaterial)
    return {
        feed_product_type: selectedMaterial.feed_product_type,
        item_sku : sku,
        size_name : modelField ,
        color_name: motiveField,
        brand_name: basisData.brand_name,
        external_product_id: ean,
        external_product_id_type: basisData.external_product_id_type,
        item_name: itemName,
        manufacturer: basisData.brand_name,
        part_number: sku,

        // list_price_with_tax: price,
        'purchasable_offer[marketplace_id=A1PA6795UKMFR9]#1.our_price#1.schedule#1.value_with_tax':price,
        // 'purchasable_offer[marketplace_id=A1PA6795UKMFR9]#1.discounted_price#1.schedule#1.value_with_tax': price,
        "fulfillment_availability#1.quantity": basisData.quantity,
        length_longer_edge: itemSize && itemSize.height|| '',
        width_shorter_edge: itemSize && itemSize.width || '',
        length_longer_edge_unit_of_measure: itemSize && itemSize.height ? 'Zentimeter' : '',
        width_shorter_edge_unit_of_measure: itemSize && itemSize.height ? 'Zentimeter' : '',
        main_image_url: images.images[0] ? images.images[0]: "",
        other_image_url1:images.images[1] ? images.images[1]: "",
        other_image_url2:images.images[2] ? images.images[2]: "",
        other_image_url3:images.images[3] ? images.images[3]: "",
        other_image_url4:images.images[4] ? images.images[4]: "",
        other_image_url5:images.images[5] ? images.images[5]: "",
        other_image_url6:images.images[6] ? images.images[6]: "",
        other_image_url7:images.images[7] ? images.images[7]: "",
        other_image_url8:images.images[8] ? images.images[8]: "",
        swatch_image_url:images.swatch ? images.swatch : "",
        parent_child: basisData.child,
        relationship_type: basisData.relationship_type,
        variation_theme: selectedMaterial.variation,
        parent_sku: selectedMaterial.parentSKU,
        update_delete:basisData.update_delete,
        recommended_browse_nodes: selectedMaterial.browse_node,
        product_description: selectedMaterial.description,
        model: sku,
        bullet_point1: selectedMaterial.bulletPoints[0],
        bullet_point2: selectedMaterial.bulletPoints[1],
        bullet_point3: selectedMaterial.bulletPoints[2],
        bullet_point4: selectedMaterial.bulletPoints[3],
        bullet_point5: selectedMaterial.bulletPoints[4],
        generic_keywords: selectedMaterial.generic_keywords,
        country_of_origin: basisData.country_of_origin,
        model_name: modelName,
        included_components: selectedMaterial.included_components,
        special_features1: selectedMaterial.specialFeatures ? selectedMaterial.specialFeatures[0]: undefined,
        special_features2: selectedMaterial.specialFeatures ? selectedMaterial.specialFeatures[1]: undefined,
        special_features3: selectedMaterial.specialFeatures ? selectedMaterial.specialFeatures[2]: undefined,
        special_features4: selectedMaterial.specialFeatures ? selectedMaterial.specialFeatures[3]: undefined,
        special_features5: selectedMaterial.specialFeatures ? selectedMaterial.specialFeatures[4]: undefined,
        color_map: colorMap,
        compatible_devices1: compatibleModels[0]? compatibleModels[0]: "",
        compatible_devices2: compatibleModels[1]? compatibleModels[1]: "",
        compatible_devices3: compatibleModels[2]? compatibleModels[2]: "",
        compatible_devices4: compatibleModels[3]? compatibleModels[3]: "",
        compatible_devices5: compatibleModels[4]? compatibleModels[4]: "",
        compatible_phone_models1: compatibleModels[0]? compatibleModels[0]: "",
        compatible_phone_models2: compatibleModels[1]? compatibleModels[1]: "",
        compatible_phone_models3: compatibleModels[2]? compatibleModels[2]: "",
        compatible_phone_models4: compatibleModels[3]? compatibleModels[3]: "",
        compatible_phone_models5: compatibleModels[4]? compatibleModels[4]: "",
        pattern_name: pattern,
        form_factor: selectedMaterial.formFactor,
        "fulfillment_availability#1.lead_time_to_ship_max_days": basisData.fulfillment_latency,
        material_type: selectedMaterial.materialType,
        style_name:selectedMaterial.styleName,
        merchant_shipping_group_name: shippingOption,
        "fulfillment_availability#1.fulfillment_channel_code": "DEFAULT"

    }

    return item
}

function convertItemsToArray(fileJSON){
    let array = []
    try {

        for (let item of fileJSON) {
            let modelItems = Object.keys(item)
            const model = item[modelItems.shift()]
            if (modelItems.length === 0) {
                continue
            }
            for (let motive of modelItems) {
                array.push({
                    model,
                    motive
                })
            }
        }
    }catch (e) {
        throw new Error("Datei konnte nicht konvertiert werden.")
    }
    return array
}



export {createParentLine, createItemLines, convertItemsToArray, createParentLineForFile, updateEANsInDatabase, downloadExceFromJson, downloadCSVFromJSON}
